import React from "react";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import AccordionPanel from "./AccordionPanel";
import StandardMoney from "../../common/StandardMoney";
import useAccount from "../hooks/useAccount";

const {
  summaryDescription,
  entitlementDescription,
  utilisationDescription,
  balanceDescription,
} = messages;

const divider = { "border-top": "1px solid grey" };

const AccountSummaries = ({ intl, account, uiConfigs, hideHeader = false }) => {
  const {
    entitled,
    totalSpend,
    available,
    salaryDeductionAmount,
    currency,
    isUnlimited,
    pointAllocations,
    totalPointAllocation,
    broughtForwardPoints,
    totalBroughtForwardPoints,
    benefitSelection,
    totalBenefitSelection,
    restUtilization,
  } = useAccount(account);

  const utilized = totalSpend;
  return (
    <div id="soa-table" style={{ "max-width": "690px" }}>
      {!hideHeader && <h3>{intl.formatMessage(summaryDescription)}</h3>}
      <div>
        <div className="apl-payment-summary__payments" style={divider}>
          <span>{intl.formatMessage(entitlementDescription)}</span>
          <span
            className="field__currency payment__price"
            style={entitled < 0 ? { float: "right", color: "red" } : { float: "right" }}
          >
            <StandardMoney value={entitled} currency={currency} />
          </span>
        </div>

        {pointAllocations.length > 0 && (
          <AccordionPanel
            intl={intl}
            subTotal={totalPointAllocation}
            records={pointAllocations}
            subHeader={uiConfigs.pointsAllocationSubHeader || "Points Allocation"}
            panelId="pointAllocationPanel"
            currency={currency}
          />
        )}

        {totalBroughtForwardPoints != 0 && broughtForwardPoints.length > 0 && (
          <AccordionPanel
            intl={intl}
            subTotal={totalBroughtForwardPoints}
            records={broughtForwardPoints}
            subHeader={uiConfigs.broughtForwardSubHeader || "Brought Forward Points"}
            panelId="broughtForwardPanel"
            currency={currency}
          />
        )}
        <div className="apl-payment-summary__payments" style={divider}>
          <span>{intl.formatMessage(utilisationDescription)}</span>
          <span
            className="field__currency payment__price"
            style={utilized < 0 ? { float: "right", color: "red" } : { float: "right" }}
          >
            <StandardMoney value={utilized} currency={currency} />
          </span>
        </div>

        {totalBenefitSelection != 0 && benefitSelection.length > 0 && (
          <AccordionPanel
            intl={intl}
            subTotal={totalBenefitSelection}
            records={benefitSelection}
            subHeader={uiConfigs.benefitSelectionSubHeader || "Benefit Selection"}
            panelId="benefitSelectionPanel"
            currency={currency}
          />
        )}
        {restUtilization.length > 0 &&
          restUtilization.map((record, idx) => {
            const { transactionType, transactionTypeId, actualAmount } = record;
            let transactionTypeDisplay = transactionType;
            if (
              transactionTypeId == "HealthAndWellnessPurchase" &&
              uiConfigs.healthAndWellnessSubHeader
            ) {
              transactionTypeDisplay = uiConfigs.healthAndWellnessSubHeader;
            } else if (
              transactionTypeId == "Reimbursement" &&
              uiConfigs.claimReimbursementSubHeader
            ) {
              transactionTypeDisplay = uiConfigs.claimReimbursementSubHeader;
            }

            return (
              actualAmount != 0 && (
                <div key={idx}>
                  <span>
                    {transactionType == transactionTypeDisplay
                      ? intl.formatMessage({
                          id: transactionType,
                          defaultMessage: transactionType,
                        })
                      : transactionTypeDisplay}
                  </span>

                  <span
                    className="field__currency"
                    style={actualAmount < 0 ? { float: "right", color: "red" } : { float: "right" }}
                  >
                    <StandardMoney value={actualAmount} currency={currency} />
                  </span>
                </div>
              )
            );
          })}
        {salaryDeductionAmount != 0 && (
          <div className="apl-payment-summary__total" style={divider}>
            <span>
              {intl.formatMessage(uiConfigs.salaryDeductionSubHeader) || "Salary Deduction"}
            </span>
            <span
              className="field__currency"
              style={
                salaryDeductionAmount < 0 ? { float: "right", color: "red" } : { float: "right" }
              }
            >
              <StandardMoney
                value={salaryDeductionAmount}
                currency={currency}
                isUnlimited={isUnlimited}
              />
            </span>
          </div>
        )}
        <div className="apl-payment-summary__total" style={divider}>
          <span>{intl.formatMessage(balanceDescription)}</span>

          <span className="field__currency" style={{ float: "right" }}>
            <StandardMoney value={available} currency={currency} isUnlimited={isUnlimited} />
          </span>
        </div>
      </div>
    </div>
  );
};

AccountSummaries.propTypes = {
  intl: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  uiConfigs: PropTypes.object.isRequired,
  hideHeader: PropTypes.bool,
};

export default AccountSummaries;



// WEBPACK FOOTER //
// ./components/claim/widgets/AccountSummaries.jsx